<template>
    <div>
        <div class="home__good-hands">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <h4>{{ $t("promo.Trust - h4 1") }}</h4>
                        <div
                            class="d-flex flex-column flex-lg-row align-items-center"
                        >
                            <div class="steps order-2 order-lg-1">
                                <div class="step-item">
                                    <div class="circle"></div>
                                    <div class="step-title">
                                        {{ $t("promo.Trust - title 1") }}
                                    </div>
                                    <p>
                                        {{ $t("promo.Trust - para 1") }}
                                    </p>
                                </div>
                                <!-- /item -->
                                <div class="step-item">
                                    <div class="circle"></div>
                                    <div class="step-title">
                                        {{ $t("promo.Trust - title 2") }}
                                    </div>
                                    <p>
                                        {{ $t("promo.Trust - para 2") }}
                                    </p>
                                </div>
                                <!-- /item -->
                                <div class="step-item">
                                    <div class="circle"></div>
                                    <div class="step-title">
                                        {{ $t("promo.Trust - title 3") }}
                                    </div>
                                    <p>
                                        {{ $t("promo.Trust - para 3") }}
                                    </p>
                                </div>
                                <!-- /item -->
                                <div class="step-item">
                                    <div class="circle"></div>
                                    <div class="step-title">
                                        {{ $t("promo.Trust - title 4") }}
                                    </div>
                                    <p>
                                        {{ $t("promo.Trust - para 4") }}
                                    </p>
                                </div>
                                <!-- /item -->
                            </div>
                            <div
                                class="photo d-none d-lg-block order-1 order-lg-2"
                                :style="{
                                    backgroundImage:
                                        'url(/images/promo/man_installing.png)',
                                }"
                            ></div>
                            <div
                                class="photo d-lg-none order-1 order-lg-2"
                                :style="{
                                    backgroundImage:
                                        'url(/images/promo/man_installing_mobile.png',
                                }"
                            ></div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6"></div>
                </div>
            </div>
        </div>
        <div class="home__info">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <h4 class="big-title">
                            {{ $t("promo.Trust - h4 2") }}
                        </h4>
                        <div class="big-subtitle">
                            {{ $t("promo.Trust - h4 2 subtitle") }}
                        </div>
                        <div
                            class="d-flex flex-column flex-lg-row justfify-content-between"
                        >
                            <div class="item">
                                <strong>
                                    {{ $t("promo.Trust - usp 1 blue") }}
                                </strong>
                                <p>
                                    {{ $t("promo.Trust - usp 1 info") }}
                                </p>
                            </div>
                            <!-- /item -->
                            <div class="item">
                                <strong>
                                    {{ $t("promo.Trust - usp 2 blue") }}
                                </strong>
                                <p>
                                    {{ $t("promo.Trust - usp 2 info") }}
                                </p>
                            </div>
                            <!-- /item -->
                            <div class="item">
                                <strong>
                                    {{ $t("promo.Trust - usp 3 blue") }}
                                </strong>
                                <p>
                                    {{ $t("promo.Trust - usp 3 info") }}
                                </p>
                            </div>
                            <!-- /item -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-6"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home {
    &__good-hands {
        padding-bottom: 40px;
        h4 {
            font-weight: 600;
            font-size: 24px;
            line-height: 28px;
            color: #141430;
            margin-bottom: 30px;
        }
        .photo {
            width: 290px;
            min-width: 290px;
            height: 370px;
            border-radius: 8px;
            background-size: cover;
            background-position: center;
            margin-left: 36px;
            @media (max-width: 1024px) {
                width: 100%;
                height: 40vw;
                margin: 0px;
                margin-bottom: 32px;
            }
        }
        .steps {
            .step-item {
                border-left: 2px solid #79c1f3;
                padding-left: 28px;
                padding-bottom: 28px;
                position: relative;
                margin-left: 12px;
                .circle {
                    position: absolute;
                    height: 24px;
                    width: 24px;
                    background: #ffffff;
                    border: 2px solid #79c1f3;
                    border-radius: 50%;
                    top: 14px;
                    left: 0;
                    transform: translateX(-50%) translateY(-50%);
                    box-shadow: 0px 0px 0px 8px #fff;
                }
                &:first-child {
                    .circle {
                        background: #dff0fd;
                    }
                }
                &:last-child {
                    border-color: transparent;
                }
                .step-title {
                    font-weight: 600;
                    font-size: 18px;
                    color: #141430;
                }
                p {
                    font-size: 16px;
                    line-height: 1.5;
                    color: #141430;
                }
            }
        }
    }
    &__info {
        .big-title {
            font-weight: 600;
            font-size: 24px;
            color: #141430;
        }
        .big-subtitle {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            color: #959bb5;
            margin-bottom: 32px;
        }
        .item {
            padding-right: 10px;
            margin-bottom: 28px;
            strong {
                font-style: normal;
                font-weight: 600;
                font-size: 28px;
                line-height: 28px;
                color: #108fe5;
                margin-bottom: 10px;
                display: block;
            }
            p {
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                color: #141430;
            }
        }
    }
}
</style>
